import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import useThemeStore from './store/themeStore';
import Navbar from './components/Navbar';
import { Helmet } from 'react-helmet-async';
import SocialMediaIconsRight from './components/SocialMediaIconsRight';

import Home from './pages/Home';
import Tours from './pages/Tours';
import News from './pages/News';
import About from './pages/About';
import Contact from './pages/Contact';
import TourDetail from './pages/TourDetail';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import Register from './pages/Register';
import PaymentPage from './pages/PaymentPage';
import UserProfile from './pages/UserProfile';
import NewsDetail from './pages/NewsDetail';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentCancel from './pages/PaymentCancel';
import Visa from './pages/services/Visa';
import Hotels from './pages/services/Hotels';
import Flights from './pages/services/Flight';

import Footer from './components/Footer';
import './index.css';

function AppContent() {
  const { isDark } = useThemeStore();
  const location = useLocation();

  // Analytics
  useEffect(() => {
    fetch("https://backend.ysskytravel.com/api/analytics/track");
  }, []);

  // Dark mode
  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  // Hide footer on admin route
  const hideFooter = location.pathname.startsWith("/admin");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:site_name" content="YS Sky Travel and Tour Agency P.L.C" />
        <meta name="author" content="YS Sky Travel and Tour Agency P.L.C" />
      </Helmet>

      <div className="min-h-screen bg-white dark:bg-slate-950 text-gray-900 dark:text-white transition-colors duration-300">

        <Navbar />
        <SocialMediaIconsRight />

        <main className="pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/about_us" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/services/visa" element={<Visa />} />
            <Route path="/services/hotels" element={<Hotels />} />
            <Route path="/services/airplane-tickets" element={<Flights />} />

            <Route path="/tour/:id" element={<TourDetail />} />
            <Route path="/admin" element={<AdminPanel />} />

            <Route path="/profile" element={<UserProfile />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/failure" element={<PaymentFailure />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/payment/:bookingId" element={<PaymentPage />} />
          </Routes>
        </main>

        {!hideFooter && <Footer />}
      </div>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
